<template>
    <div class='box'>
        <div class='summary'>
            <!-- <div class="franchisee" @click="storeIntroUrl(order)"> -->
            <div class="franchisee">
                {{order.storeName}}
            </div>
            <div class='date'>{{order.time}}</div>
            <div class='nameNTotal'>
                {{order.repMenuName}}
                <span v-if='order.orderMenuCount > 1'>
                    외<strong class='emphasis'> {{order.orderMenuCount - 1}}건</strong>
                </span>
            </div>
            <div class='price' :class='{stock_box: isCancelled}'>
                <span v-if='isCancelled' class='label_Box pink'>
                    {{$t('MyPage.cancelled')}}
                </span>
                <span v-else-if='fullVUi' class='label_Box'>
                    {{this.companyType == 5 ? $t('OrderPage.shopping') : $t(`${getOrderType(order.packingFlag)}`)}}
                </span>
                <strong class='no' :class='{total_t:isCancelled}'>{{formatComma(order.price)}}</strong>
            </div>
        </div>
        <div v-for='(store, index) in order.storeOrderList' :key='index' class='myOrderNo'>
            <div class='storeName'>{{store.name}}</div>
            <div class='box'>
                <span class='tit'>{{$t('MyPage.orderNumber')}}</span>
                    <strong class='no'  v-if="store.pickupNo">{{store.pickupNo}}</strong>
                    <strong v-else-if="!store.pickupNo">알림톡 주문번호를 확인해주세요</strong>
            </div>
        </div>
        <!-- 주문내역 보기 -->
        <a
            class='btnBasic btn gr btnMyOrder btnOpenModal'
            @click.stop.prevent='$emit("requestOrderDetail", order.orderCode)'>
            {{$t('MyPage.viewOrderHistory')}}
        </a>
    </div>
</template>
<script lang="js">
import { ORDER_CANCEL } from '@/utils/Code'
import { ORDER_HISTORY_ITEM } from '@/utils/EndPoint'
import service from '@/backend/modnpay_app_api'
export default ({
  name: ORDER_HISTORY_ITEM,
  props: ['order'],
  data () {
    return {
      isCancelled: this.order.orderProgressFlag === ORDER_CANCEL,
      companyType: this.$store.getters.companyType
    }
  },
  computed: {
    fullVUi () { return this.$store.getters.fullVUi }
  },
  method: {
    async storeIntroUrl (order) {
      const req = {
        urlCode: order.StoreGroupCode,
        introUrlType: order.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      window.location.href = data.introUrl
    }
  }
})
</script>
